import { render } from "./PaginationClients.vue?vue&type=template&id=75f71ff5&scoped=true"
import script from "./PaginationClients.vue?vue&type=script&lang=js"
export * from "./PaginationClients.vue?vue&type=script&lang=js"

import "./PaginationClients.vue?vue&type=style&index=0&id=75f71ff5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f71ff5"]])

export default __exports__